module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-6_BW-p-800-aee24515ff6465515339842236f7d86c.jpg";